module.exports = __webpack_public_path__ + "files/5ad8c32e52e253d7a798ee15f749c2ef.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/Ubuntu-regular.woff2
 ** module id = 883
 ** module chunks = 0
 **/